<template>
  <div class="table">
    <a-modal v-model="visible" :title="title" width="1200px" :footer="null" :destroyOnClose='true'>
      <a-table :columns="columnsKey" :data-source="list" :loading="loading" :pagination='false' class="tablebox">
        <!-- <div v-if='type!=3'>
          <div slot="causeno" slot-scope="text, record" v-if='record'>
            {{record.cause.no}}
          </div>
          <div slot="realname" slot-scope="text, record" v-if='record'>
            {{record.cause.debtor.realname}}
          </div>
          <div slot="title" slot-scope="text, record" v-if='record'>
            {{record.cause.accuser.title}}
          </div>
        </div> -->
        <div slot="alist" slot-scope="text, record" v-if='record'>
          <!-- <router-link v-if="$common.AUTH('1-1')" :to="{ name: 'paybacksee', params: { id: record.id } }">查看</router-link> -->
          <div v-if='type!=3'>
            <span v-if='$common.AUTH("loan:info:lists")'>
              <router-link target="_blank" :to="{ name: 'paybacksee', params: { id: record.loan_id } }">查看</router-link>
            </span>
            <span v-else>查看</span>
          </div>
          <div v-else>
            <span v-if='$common.AUTH("debtor:info")'>
              <router-link target="_blank" :to="{ name: 'lydetails', params: { id: record.debtor_id } }">修改</router-link>
            </span>
            <span v-else>查看</span>
          </div>
          <!-- <div>查看</div> -->
        </div>
      </a-table>
      <div style="text-align:center;padding-top:20px;" v-if='count>10'>
        <a-pagination v-model="pagination.page" :total="count" show-quick-jumper show-less-items @change='turn' />
      </div>
    </a-modal>
  </div>
</template>
<script>

const columns = [
  { title: '分期号', dataIndex: 'no', width: 200 },
  { title: '还款时间', dataIndex: 'time', width: 100 },
  { title: '总欠款', dataIndex: 'fee', width: 100 },
  { title: '已还款', dataIndex: 'payee', width: 100 },
  { title: '案件编号', dataIndex: 'causeno', width: 150 },
  { title: '债务人姓名', dataIndex: 'realname', width: 100 },
  { title: '原告姓名', dataIndex: 'title', width: 150 },
  {
    title: '操作',
    key: 'alist',
    dataIndex: 'alist',
    scopedSlots: { customRender: 'alist' },
    width: 100,
  },
];
const columns1 = [
  { title: '保全时间', dataIndex: 'stime' },
  { title: '保全到期时间', dataIndex: 'etime' },
  { title: '资产信息', dataIndex: 'content' },
  { title: '债务人姓名', dataIndex: 'realname', width: 200 },
  {
    title: '操作',
    key: 'alist',
    dataIndex: 'alist',
    scopedSlots: { customRender: 'alist' },
    width: 200,
  },
]
export default {
  props: {
    type: Number,
    title: String
  },
  computed: {
    columnsKey() {
      if (this.type == 3) {
        return columns1
      } else {
        return columns
      }
    }
  },
  data() {
    return {
      visible: false,
      list: [],
      count: 0,
      pagination: {
        limit: 10,
        page: 1
      },
      loading: true,
    }
  },
  watch: {
    type(val) {
      this.getList()
    }
  },
  methods: {
    turn(val) {
      this.pagination.page = val
      this.getList()
    },
    getList() {
      this.loading = true;
      if (this.type == 1) {
        this.$store.dispatch("Case/getloadFuture", this.pagination).then(e => {
          e.list.map(ele => {
            ele.causeno = ele.cause.no
            ele.realname = ele.cause.debtor.realname
            ele.title = ele.cause.accuser.title
            ele.payee = (ele.payee / 100).toFixed(2)
            ele.fee = (ele.fee / 100).toFixed(2)
          })
          this.list = e.list
          this.count = e.count
          this.loading = false;
        })
      }
      else if (this.type == 2) {
        this.$store.dispatch("Case/getloadOverdue", this.pagination).then(e => {
          e.list.map(ele => {
            ele.causeno = ele.cause.no
            ele.realname = ele.cause.debtor.realname
            ele.title = ele.cause.accuser.title
            ele.payee = (ele.payee / 100).toFixed(2)
            ele.fee = (ele.fee / 100).toFixed(2)
          })
          this.list = e.list
          this.count = e.count
          this.loading = false;
        })
      } else {
        this.$store.dispatch("Case/getdebtorExpire", this.pagination).then(e => {
          e.list.map(ele => {
            ele.realname = ele.debtor.realname
            ele.stime = ele.stime.slice(0, 10)
            ele.etime = ele.etime.slice(0, 10)
          })
          // console.log(e.list)
          this.list = e.list
          this.count = e.count
          this.loading = false;
        })
      }
    },
  }
}
</script>
<style lang="less" scoped>
.tablebox {
  min-height: 500px;
}
</style>